module.exports = __webpack_public_path__ + "static/media/3_Heaven and hell_FR.330caa45.txt";